const cloud = {
    general: {
        onboarding: 'آشنایی با سیستم',
    },
    create_tenant: {
        page_title: 'ایجاد مستأجر',
        title: 'اولین مستأجر خود را ایجاد کنید',
        description: 'مستأجر یک محیط ایزوله است که در آن می‌توانید هویت‌های کاربری، برنامه‌ها و تمام منابع دیگر Logto را مدیریت کنید.',
        invite_collaborators: 'همکاران خود را از طریق ایمیل دعوت کنید',
    },
    social_callback: {
        title: 'شما با موفقیت وارد شدید',
        description: 'شما با موفقیت با استفاده از حساب اجتماعی خود وارد شده‌اید. برای اطمینان از یکپارچه‌سازی بدون مشکل و دسترسی به تمام ویژگی‌های Logto، توصیه می‌کنیم که اتصال‌دهنده اجتماعی خود را پیکربندی کنید.',
        notice: 'لطفاً از اتصال‌دهنده آزمایشی برای اهداف تولیدی استفاده نکنید. پس از اتمام آزمایش، لطفاً اتصال‌دهنده آزمایشی را حذف کرده و اتصال‌دهنده خود را با اطلاعات کاربری خود تنظیم کنید.',
    },
    tenant: {
        create_tenant: 'ایجاد مستأجر',
    },
};
export default Object.freeze(cloud);
